import React from 'react';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert } from '../../../actions';
import TranslationService from "../../../app/services/TranslationService";


class HistoryDirectoryClass extends React.Component {
    /**
     * @param props
     */
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            title: ''
        };
    }

    renderTalks = (dirName) => {
        let rows = [];

        let that = this;
        this.props.talks.forEach(function(talk) {
            rows.push(
                <li
                    key={talk.id}
                    className={'imd-text-contrast talk' + (that.props.currentTalk !== null && that.props.currentTalk === talk.id ? ' active' : '')}
                    onClick={() => that.props.open(talk.id)}
                >
                    <span
                        className={'imd-icon imd-icon-edit-pencil action-icon'}
                        onClick={(e) => {e.stopPropagation(); that.props.edit(talk.id, '[' + dirName + '] ' + talk.title)}}
                    />

                    {talk.title}
                </li>
            );
        });

        return rows;
    }

    /**
     * @returns {XML}
     */
    render() {
        return (
            <div className={'directory'} onClick={() => this.setState({show: !this.state.show})}>
                <span className={'icon imd-icon imd-icon-folder imd-text-contrast'} />
                <span className={'imd-text-contrast'}>{this.props.title}</span>

                <ul style={{display: this.state.show ? 'block' : 'none'}}>
                    {this.renderTalks(this.props.title)}
                </ul>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {}
};

export const HistoryDirectory = connect(mapStateToProps, { preloaderShow, preloaderHide, alert })(HistoryDirectoryClass);
